import React from "react";
import DividerBlock from "../../../../divider-block";
import FieldBlock from '../../../../field-block';
import { DatePicker, TimePicker } from "antd";
import { Col, Row } from "antd";
import NumberInputField from "../../../../number-input-field";
import i18n from "../../../../../i18n";

const { RangePicker } = DatePicker;

export default function Reduction({
  tenderTimeStart,
  tenderTimeEnd,
  setLoadStart,
  setLoadEnd,
  setTenderStart,
  setTenderEnd,
  setTenderTimeStart,
  setTenderTimeEnd,
  getFieldErrors,
  maxPrice,
  setMaxPrice,
  stepPrice,
  setStepPrice,
  dividerStyle}
) {
    return (
      <>
      <span className="divider-label">{i18n.t('consignorPage.createDelivery.content.divider.reduction')}</span>
      <DividerBlock style={dividerStyle} />
      <Row gutter={[16, 24]} >
        <Col lg={12} md={24} sm={24} sx={24}>
          <FieldBlock  name="tenderStart" title={i18n.t('consignorPage.createDelivery.content.reduction.tenderStart')} getErrors={getFieldErrors}>
            <RangePicker
              style={{ width: "100%" }}
              format="YYYY-MM-DD"
              onChange={(date) => {
                  setTenderStart(date[0]);
                  setTenderEnd(date[1]);
              }}
            />
            <TimePicker
              defaultValue={tenderTimeStart}
              placeholder={i18n.t('consignorPage.createDelivery.content.tenderTimeStart')}
              format="HH:mm"
              onChange={(time, timeString) => {setTenderTimeStart(time)}}
              style={{ width: "50%" }}
            />
            <TimePicker
              placeholder={i18n.t('consignorPage.createDelivery.content.tenderTimeEnd')}
              defaultValue={tenderTimeEnd}
              format="HH:mm"
              onChange={(time, timeString) => {setTenderTimeEnd(time)}}
              style={{ width: "50%" }}
            />
          </FieldBlock>
        </Col>
      </Row>
      <Row gutter={[16, 24]} >
        <Col lg={12} md={24} sm={24} sx={24}>
          <NumberInputField
            name="maxPrice" label={i18n.t('consignorPage.createDelivery.content.maxPrice')}
            value={maxPrice} setValue={setMaxPrice}
            getFieldErrors={getFieldErrors}
          />
        </Col>
        <Col lg={12} md={24} sm={24} sx={24}>
          <NumberInputField
            name="stepPrice" label={i18n.t('consignorPage.createDelivery.content.stepPrice')}
            value={stepPrice} setValue={setStepPrice}
            getFieldErrors={getFieldErrors}
          />
        </Col>
      </Row>
      </>
    );
}
